import { Injectable } from '@angular/core';
import * as Blockly from 'blockly';
import { BlocklyHelperService } from './blockly-helper.service';
import { EventsStringService } from 'src/app/shared/services/events-string.service';
import { EventIdRegistryService } from 'src/app/shared/services/event-id-registry.service';
import { DialogRecorderIdRegistryService } from 'src/app/shared/services/dialog-recorder-id-registry.service';
import { GroupchatChannelRegistryService } from 'src/app/shared/services/groupchat-channel-registry.service';
import { ProjectSecretService } from 'src/app/shared/services/project-secret.service';
import { RouteShareService } from 'src/app/shared/services/route-share.service';
import { BlocklyCategory_HELPERS_DIALOGRECORDER, BlocklyCategory_HELPERS_AIGENERATORS, BlocklyCategory_HELPERS_CONTROL, BlocklyCategory_HELPERS_DEBUG, BlocklyCategory_HELPERS_EXTRAS, BlocklyCategory_HELPERS_GROUP, BlocklyCategory_HELPERS_IF, BlocklyCategory_HELPERS_MAIL } from './blockly-categories/allHelpers.category';
import { BlocklyCategory_BUTTONS } from './blockly-categories/buttons.category';
import { BlocklyCategory_COMMON } from './blockly-categories/common-blocks.category';
import { BlocklyCategory_EVENTS } from './blockly-categories/events.category';
import { BlocklyCategory_BEFORE_SEND } from './blockly-categories/before-send.category';
import { BlocklyCategory_MESSAGES } from './blockly-categories/messages.category';
import { BlocklyCategory_CHAT_CARDS } from './blockly-categories/chat-cards.category';
import { BlocklyCategory_OVERLAYS } from './blockly-categories/overlays.category';
import { BlocklyCategory_SCORES } from './blockly-categories/scores.category';
import { BlocklyCategory_SKILLS } from './blockly-categories/skills.category';
import { BlocklyCategory_STAGES } from './blockly-categories/stages.category';
import { BlocklyCategory_DOCSEARCH } from './blockly-categories/docsearch.category';
import { BlocklyCategory_VIEW_AUDIO } from './blockly-categories/view-audio.category';
import { BlocklyCategory_VIEW_AVATAR } from './blockly-categories/view-avatar.category';
import { BlocklyCategory_VIEW_CHAT } from './blockly-categories/view-chat.category';
import { BlocklyCategory_VIEW_FUSION } from './blockly-categories/view-funsion.category';
import { BlocklyCategory_VIEW_FUSION_RISE } from './blockly-categories/view-fusion-rise';
import { BlocklyCategory_VIEW_FUSION_VIMEO } from './blockly-categories/view-fusion-vimeo.category';
import { BlocklyCategory_VIEW_FUSION_YOUTUBE } from './blockly-categories/view-fusion-youtube.category';

import { BlocklyCategory_WENNDANN } from './blockly-categories/wendann.category';
import { BlocklyCategory_WENNDANN_SPECIFIC, WENNDANN_SPECIFIC_CATEGORY_NAME } from './blockly-categories/wenndann-specific.category';
import { resetStackBlockRegistration } from './field-stack-dropdown';
import { BlockkyPlaygroundService } from './blockly-playground.service';
import { BlockkyRAGAIManagersService } from './blockly-RAGAI-Managers.service';
import { adjustColorBrightness, BLOCKLY_COLORS, BlocklyToolboxCategory, BlocklyToolboxSep } from './blocky-types.types';
import { BLOCKLY_HIDDEN_BLOCKS } from './blockly-hidden-blocks';
import { BlocklyCategory_QUIZ } from './blockly-categories/quiz.category';
import { BlocklyCategory_ON_SITE } from './blockly-categories/on-site.category';
import { BlocklyCategory_DEPRECATED } from './blockly-categories/deprecated.category';
import { BlocklyCategory_OBJECTS } from './blockly-categories/create_object_with.magic.category';
import { BlocklyCategory_VIEW_FUSION_LXT } from './blockly-categories/view-fusion-lxt';
import { BlocklyCategory_VARIABLES_magic } from './blockly-categories/variables.magic.category';
import { ExpertCategory_MSG, ExpertCategory_KEYVAL, ExpertCategory_PROJECTKEYVAL, ExpertCategory_CARDS, ExpertCategory_OVERLAY, ExpertCategory_STAGE, ExpertCategory_EVENTS as ExpertCategory_EVENTS_FN, ExpertCategory_WAITFOR, ExpertCategory_HELPER, ExpertCategory_DOWNLOAD, ExpertCategory_WEBHOOK, ExpertCategory_AUDIO, ExpertCategory_CHAT_AVATAR, ExpertCategory_VIDEO_AVATAR, ExpertCategory_SCORE, ExpertCategory_SKILL, ExpertCategory_DOM, ExpertCategory_DOCSEARCH as ExpertCategory_DOCSEARCH_FN, ExpertCategory_AITEXT_OPENAI, ExpertCategory_AITEXT_VLLM, ExpertCategory_AIIMAGE, ExpertCategory_SCORM, ExpertCategory_MAIL, ExpertCategory_FUSIONVIEW, ExpertCategory_YOUTUBE, ExpertCategory_VIMEO, ExpertCategory_DIALOGRECORDER, ExpertCategory_DIALOGSTORE, ExpertCategory_SUPERVISOR, ExpertCategory_QUIZ as ExpertCategory_QUIZ_FN, ExpertCategory_PARENT, ExpertCategory_BOTAPI, ExpertCategory_BEFORE_SEND, ExpertCategory_LOG, ExpertCategory_INFO, ExpertCategory_MISC, ExpertCategory_GROUPCHAT } from './blockly-categories/expert-ragai.category';

type ToolboxItemInfo = Blockly.utils.toolbox.ToolboxItemInfo;

@Injectable({
  providedIn: 'root'
})
export class BlocklyMenuService {
  constructor(
    private blocklyPlaygorund: BlockkyPlaygroundService,
    private ragAIManagers: BlockkyRAGAIManagersService,
    private BH: BlocklyHelperService,
    private rss: RouteShareService,
    private eventStrings: EventsStringService,
    private eventIdRegistry: EventIdRegistryService,
    private dialogRecorderIdRegistry: DialogRecorderIdRegistryService,
    private groupchatChannelRegistry: GroupchatChannelRegistryService,
    private sectretService: ProjectSecretService
  ) { }

  public getItems(): ToolboxItemInfo[] {
    // Phase 1: Alle Kategorien initialisieren, damit sämtliche Blöcke
    // beim Blockly-Framework registriert werden (Reihenfolge egal).
    const steuerung = this.categoryWithContext(adjustColorBrightness(BLOCKLY_COLORS.CAT_START_ABLAUF, 5), 'ri-pulse-fill',
      () => BlocklyCategory_HELPERS_CONTROL("Steuerung", this.BH, 'ri-pulse-fill'));
    const stages = this.categoryWithContext(adjustColorBrightness(BLOCKLY_COLORS.CAT_START_ABLAUF, 15), 'ri-stack-fill',
      () => BlocklyCategory_STAGES("Stages", this.BH, this.rss, 'ri-stack-fill'));
    // WAITFOR-Blöcke wurden in "Veraltete Blöcke" verschoben – nur noch Registrierung der Block-Typen
    this.categoryWithContext(adjustColorBrightness(BLOCKLY_COLORS.CAT_START_ABLAUF, 25), 'ri-pause-circle-line',
      () => this.ragAIManagers.WAITFORBlocks("RAGAI_WAITFOR"));
    const skills = this.categoryWithContext(adjustColorBrightness(BLOCKLY_COLORS.CAT_START_ABLAUF, 20), 'ri-remix-fill',
      () => BlocklyCategory_SKILLS("Skills", this.BH, this.rss));

    const nachrichten = this.categoryWithContext(BLOCKLY_COLORS.MESSAGES, 'ri-chat-2-line',
      () => BlocklyCategory_MESSAGES("Nachrichten und Texte", this.BH));
    const buttons = this.categoryWithContext(BLOCKLY_COLORS.BUTTONS, 'ri-toggle-line',
      () => BlocklyCategory_BUTTONS("Nutzer Interaktion", this.BH));
    const weitereChatinhalte = this.categoryWithContext(BLOCKLY_COLORS.MESSAGES, 'ri-layout-grid-line',
      () => BlocklyCategory_CHAT_CARDS("Mediainhalte", this.BH));
    const overlays = this.categoryWithContext(BLOCKLY_COLORS.OVERLAYS, 'ri-layout-masonry-line',
      () => BlocklyCategory_OVERLAYS("Overlays", this.BH));

    const ereignisse = this.categoryWithContext(BLOCKLY_COLORS.EVENTS, 'ri-flashlight-line',
      () => BlocklyCategory_EVENTS("Ereignisse", this.BH, this.eventStrings, this.eventIdRegistry));
    const vorDemSenden = this.categoryWithContext(BLOCKLY_COLORS.BEFORE_SEND, 'ri-filter-line',
      () => BlocklyCategory_BEFORE_SEND("Vor dem Senden", this.BH));
    // Wenn-Dann-Blöcke wurden in "Veraltete Blöcke" verschoben – nur noch Registrierung der Block-Typen
    this.categoryWithContext(BLOCKLY_COLORS.WENNDANN, 'ri-git-branch-line',
      () => BlocklyCategory_WENNDANN("Wenn-Dann", this.BH, this.rss));
    // Benachrichtigungen (toastr) wurden in "Veraltete Blöcke" verschoben – nur noch Registrierung der Block-Typen
    this.categoryWithContext(BLOCKLY_COLORS.CAT_EREIGNISSE, 'ri-notification-3-line',
      () => this.ragAIManagers.toastrBlocks("Benachrichtigungen"));

    const kiText = this.categoryWithContext(BLOCKLY_COLORS.CAT_KI_FUNKTIONEN, 'ri-robot-2-line',
      () => this.ragAIManagers.AITEXT_OPENAIBlocks("KI-Text"));
    const kiContent = this.categoryWithContext(BLOCKLY_COLORS.CAT_KI_FUNKTIONEN, 'ri-magic-line',
      () => BlocklyCategory_HELPERS_AIGENERATORS("KI-Content", this.BH));
    const docsearch = this.categoryWithContext(BLOCKLY_COLORS.CAT_DATEN_INHALTE, 'ri-file-text-line',
      () => BlocklyCategory_DOCSEARCH("Dokumente", this.BH, this.rss));

    const bausteine = this.categoryWithContext(BLOCKLY_COLORS.CAT_DATEN_INHALTE, 'ri-puzzle-line',
      () => BlocklyCategory_COMMON("Bausteine & Variablen", this.BH, this.rss, this.sectretService));
    const keyval = this.categoryWithContext(BLOCKLY_COLORS.CAT_DATEN_INHALTE, 'ri-save-3-line',
      () => this.ragAIManagers.KEYVALCombinedBlocks("Datenspeicher"));
    const groupchat = this.categoryWithContext(BLOCKLY_COLORS.CAT_KI_FUNKTIONEN, 'ri-chat-1-line',
      () => this.ragAIManagers.GroupchatBlocks("Bot-to-Bot-Nachricht", this.groupchatChannelRegistry));
    const download = this.categoryWithContext(BLOCKLY_COLORS.CAT_DATEN_INHALTE, 'ri-download-line',
      () => this.ragAIManagers.DownloadBlocks("Up/Download"));

    const botView = this.categoryWithContext(BLOCKLY_COLORS.CAT_DARSTELLUNG, 'ri-chat-1-line',
      () => BlocklyCategory_VIEW_CHAT("Bot-View", this.BH));
    const botAvatar = this.categoryWithContext(BLOCKLY_COLORS.CAT_DARSTELLUNG, 'ri-user-smile-line',
      () => BlocklyCategory_VIEW_AVATAR("Bot-Avatar", this.BH));
    const botAudio = this.categoryWithContext(BLOCKLY_COLORS.CAT_DARSTELLUNG, 'ri-volume-up-line',
      () => BlocklyCategory_VIEW_AUDIO("Bot-Audio", this.BH));
    const fusionView = this.categoryWithContext(BLOCKLY_COLORS.FUSION, 'ri-tv-line',
      () => BlocklyCategory_VIEW_FUSION("Fusion-View", this.BH, this.rss._allFusionData()));
    const fusionYoutube = this.categoryWithContext(BLOCKLY_COLORS.FUSION, 'ri-youtube-line',
      () => BlocklyCategory_VIEW_FUSION_YOUTUBE("Fusion Youtube", this.BH, this.eventStrings));
    const fusionVimeo = this.categoryWithContext(BLOCKLY_COLORS.FUSION, 'ri-video-line',
      () => BlocklyCategory_VIEW_FUSION_VIMEO("Fusion Vimeo", this.BH, this.eventStrings));
    const fusionRise = this.categoryWithContext(BLOCKLY_COLORS.FUSION, 'ri-book-open-line',
      () => BlocklyCategory_VIEW_FUSION_RISE("Fusion Rise", this.BH, this.eventStrings));
    const fusionLxt = this.categoryWithContext(BLOCKLY_COLORS.FUSION, 'ri-book-2-line',
      () => BlocklyCategory_VIEW_FUSION_LXT("Fusion LXT", this.BH, this.eventStrings));

    const webhook = this.categoryWithContext(BLOCKLY_COLORS.CAT_INTEGRATIONEN, 'ri-global-line',
      () => this.ragAIManagers.WEBHOOKBlocks("Webhook"));
    const mail = this.categoryWithContext(BLOCKLY_COLORS.CAT_INTEGRATIONEN, 'ri-mail-send-line',
      () => BlocklyCategory_HELPERS_MAIL("Mail", this.BH));
    const adobeConnect = this.categoryWithContext(BLOCKLY_COLORS.CAT_INTEGRATIONEN, 'ri-video-chat-line',
      () => this.ragAIManagers.AdobeConnectBlocks("Adobe Connect"));
    const scorm = this.categoryWithContext(BLOCKLY_COLORS.CAT_INTEGRATIONEN, 'ri-computer-line',
      () => this.ragAIManagers.SCORMBlocks("SCORM"));
    const onSite = this.categoryWithContext(BLOCKLY_COLORS.CAT_INTEGRATIONEN, 'ri-window-line',
      () => BlocklyCategory_ON_SITE("On-Site Bot", this.BH));
    const scores = this.categoryWithContext(BLOCKLY_COLORS.CAT_INTEGRATIONEN, 'ri-trophy-line',
      () => BlocklyCategory_SCORES("Scores", this.BH));

    const bedingungen = this.categoryWithContext(BLOCKLY_COLORS.CAT_LOGIK_CODE, 'ri-git-branch-line',
      () => BlocklyCategory_HELPERS_IF("Bedingungen", this.BH));
    const aktionen = this.categoryWithContext(BLOCKLY_COLORS.CAT_LOGIK_CODE, 'ri-file-list-3-line',
      () => BlocklyCategory_HELPERS_GROUP("Aktionen & Notizen", this.BH));
    const dialogRecorder = this.categoryWithContext(BLOCKLY_COLORS.CAT_DATEN_INHALTE, 'ri-mic-line',
      () => BlocklyCategory_HELPERS_DIALOGRECORDER("Dialog Recorder", this.BH, this.dialogRecorderIdRegistry));
    const code = this.categoryWithContext('#000000', 'ri-terminal-box-line',
      () => BlocklyCategory_HELPERS_DEBUG("Code", this.BH));
    const helfer = this.categoryWithContext(BLOCKLY_COLORS.CAT_LOGIK_CODE, 'ri-lifebuoy-line',
      () => this.ragAIManagers.HelperBlocks("Helfer"));

    // Extras (enthält CONFETTI u.a.) – muss vor Quiz registriert werden
    const extras = this.categoryWithContext(BLOCKLY_COLORS.CAT_LOGIK_CODE, 'ri-sparkling-line',
      () => BlocklyCategory_HELPERS_EXTRAS("Extras", this.BH));

    // Quiz – referenziert CONFETTI, daher nach Extras
    const quiz = this.categoryWithContext(BLOCKLY_COLORS.CAT_KI_FUNKTIONEN, 'ri-question-line',
      () => BlocklyCategory_QUIZ("Quiz", this.BH));

    // Veraltete Blöcke – KEIN categoryWithContext, damit die Blöcke ihre Originalfarbe behalten
    // Initialisierung hier, damit alle Blöcke registriert werden. Der Eintrag selbst
    // wird über getDeprecatedItem() ins Menü eingefügt (ganz unten, kleiner).
    this.getDeprecatedItem();

    // Phase 2: Menü-Struktur zusammenbauen
    let r = [
      this.group("Start & Ablauf", [steuerung, stages, skills, ereignisse, vorDemSenden], BLOCKLY_COLORS.CAT_START_ABLAUF),
      this.group("Chatinhalte & Interaktionen", [nachrichten, weitereChatinhalte, buttons, overlays], BLOCKLY_COLORS.CAT_CHAT_AUSGABE),
      this.group("KI-Funktionen", [kiText, kiContent, quiz, groupchat], BLOCKLY_COLORS.CAT_KI_FUNKTIONEN),
      this.group("Daten & Inhalte", [docsearch, bausteine, keyval, download, dialogRecorder], BLOCKLY_COLORS.CAT_DATEN_INHALTE),
      this.group("Darstellung", [botView, botAvatar, botAudio, fusionView, fusionYoutube, fusionVimeo, fusionRise, fusionLxt], BLOCKLY_COLORS.CAT_DARSTELLUNG),
      this.group("Integrationen", [webhook, mail, adobeConnect, scorm, onSite, scores], BLOCKLY_COLORS.CAT_INTEGRATIONEN),
      this.group("Logik & Code", [bedingungen, aktionen, extras, helfer, code], BLOCKLY_COLORS.CAT_LOGIK_CODE)
    ];
    return r;
  }

  /**
   * test
   * Gibt die "Veraltete Blöcke"-Kategorie zurück.
   * Wird separat ans Ende der Toolbox gehängt (nach dem Experten-Modus-Toggle).
   */
  public getDeprecatedItem(): BlocklyToolboxCategory {
    const cat = BlocklyCategory_DEPRECATED("Veraltete Blöcke", this.BH);
    cat.colour = BLOCKLY_COLORS.DEPRECATED;
    cat.cssconfig = { ...cat.cssconfig, icon: 'ri-delete-bin-line', row: 'blockly-deprecated-row' };
    return cat;
  }

  /**
   * Löscht alle bot-spezifischen BLOCK_STACK_*-Blöcke aus dem globalen Blockly-Register
   * und registriert sie anhand der aktuellen Bot-Daten neu.
   * Muss beim Bot-Wechsel (uniqueId-Change) vor loadWorkspace() aufgerufen werden.
   */
  public refreshDynamicBlocks(): void {
    // Alle BLOCK_STACK_* Blöcke (und BLOCK_STACK) aus dem prozesslebenslanges Blockly-Register
    // entfernen, damit defineBlock() die Early-Return-Guard nicht mehr trifft.
    const blocklyBlocks = Blockly.Blocks as Record<string, unknown>;
    for (const type of Object.keys(blocklyBlocks)) {
      if (type.startsWith('BLOCK_STACK')) {
        delete blocklyBlocks[type];
      }
    }

    // BLOCK_STACK-Registrierungs-Flag zurücksetzen, damit registerStackBlock() erneut läuft.
    resetStackBlockRegistration();

    // Kategorie-Funktionen erneut aufrufen – ihr Seiteneffekt ist die Block-Registrierung
    // mit frischen Daten aus rss (aktuelle Bot-Stages, Skills, Dokumente, …).
    this.categoryWithContext(adjustColorBrightness(BLOCKLY_COLORS.CAT_START_ABLAUF, 15), 'ri-stack-fill',
      () => BlocklyCategory_STAGES('Stages', this.BH, this.rss, 'ri-stack-fill'));
    this.categoryWithContext(adjustColorBrightness(BLOCKLY_COLORS.CAT_START_ABLAUF, 20), 'ri-remix-fill',
      () => BlocklyCategory_SKILLS('Skills', this.BH, this.rss));
    this.categoryWithContext(BLOCKLY_COLORS.CAT_DATEN_INHALTE, 'ri-file-text-line',
      () => BlocklyCategory_DOCSEARCH('Dokumente', this.BH, this.rss));
    this.categoryWithContext(BLOCKLY_COLORS.CAT_DATEN_INHALTE, 'ri-puzzle-line',
      () => BlocklyCategory_COMMON('Bausteine & Variablen', this.BH, this.rss, this.sectretService));
  }

  /**
   * Baut die kontextabhängige Kategorie "Wenn-Dann Spezifische Werte" neu auf, basierend
   * auf dem aktuell in rss.editorItem ausgewählten Editor. Gibt `null` zurück, wenn der
   * aktive Editor kein Wenn-Dann-Editor ist – in diesem Fall muss der Aufrufer die
   * Kategorie aus der Sidebar entfernen.
   * Wird bei jedem Editor-Wechsel neu aufgerufen (siehe BlocklyEditorComponent.ngOnChanges).
   */
  public buildWennDannSpecificCategory(): BlocklyToolboxCategory | null {
    const icon = 'ri-git-branch-line';
    const blockIcon = icon.replace('blockly-ri ', '').trim();
    this.BH.setCategoryContext(BLOCKLY_COLORS.WENNDANN, blockIcon);
    const cat = BlocklyCategory_WENNDANN_SPECIFIC(WENNDANN_SPECIFIC_CATEGORY_NAME, this.BH, this.rss);
    this.BH.clearCategoryContext();
    if (!cat) {
      return null;
    }
    cat.cssconfig = { ...cat.cssconfig, icon };
    if (!cat.colour) {
      cat.colour = BLOCKLY_COLORS.WENNDANN;
    }
    if (cat.contents) {
      cat.contents = cat.contents.filter(item => !(item.kind === 'block' && item.type && BLOCKLY_HIDDEN_BLOCKS.includes(item.type)));
    }
    return cat;
  }

  /**
   * Erzeugt eine Kategorie mit Farb- und Icon-Kontext.
   * Alle Blöcke, die innerhalb von catFactory() erstellt werden,
   * erben automatisch die angegebene Farbe und das Icon.
   */
  private categoryWithContext(
    colour: string | number,
    icon: string,
    catFactory: () => BlocklyToolboxCategory
  ): BlocklyToolboxCategory {
    const blockIcon = icon.replace('blockly-ri ', '').trim();
    this.BH.setCategoryContext(colour, blockIcon);
    const cat = catFactory();
    this.BH.clearCategoryContext();
    cat.cssconfig = { ...cat.cssconfig, icon };
    if (!cat.colour) {
      cat.colour = colour;
    }
    if (cat.contents) {
      cat.contents = cat.contents.filter(item => !(item.kind === 'block' && item.type && BLOCKLY_HIDDEN_BLOCKS.includes(item.type)));
    }
    return cat;
  }

  public group(name: string = "Toolbox Group", cat: BlocklyToolboxCategory[] = [], colour?: string, icon?: string) {
    for (const category of cat) {
      const labelText = `${name} > ${category.name}`;
      if (!category.contents) {
        category.contents = [];
      }
      const firstItem = category.contents[0];
      if (!(firstItem && firstItem.kind === 'label' && firstItem.text === labelText)) {
        category.contents.unshift({ kind: 'label', text: labelText } as any);
      }
      if (category.contents.length > 1) {
        const topItem = category.contents[0];
        const secondItem = category.contents[1];
        if (topItem?.kind === 'label' && secondItem?.kind === 'label') {
          category.contents.splice(1, 1);
        }
      }
    }



    const group: BlocklyToolboxCategory = { kind: 'category', name: name, contents: [] };
    if (colour) {
      group.colour = colour;

    }
    group.cssconfig = { row: 'blockly-parent-row', ...(icon ? { icon } : {}) };
    // @ts-ignore
    group.contents.push(...cat);
    return group;
  }

  /**
   * Experten-Toolbox: Alle RAGAI Sub-Services mit ihren Public-Methoden.
   * Jeder Service ist eine eigene Top-Level-Kategorie.
   */
  public getExpertItems(): ToolboxItemInfo[] {
    // OBJ – registriert den RAGAIOBJ Block für JSON-Eingaben
    this.BH.ragaiObj("RAGAIOBJ");
    return [
      this.categoryWithContext('#7B1FA2', 'ri-image-ai-line', () => ExpertCategory_AIIMAGE("AIIMAGE", this.BH)),
      this.categoryWithContext('#4A148C', 'ri-brain-line', () => ExpertCategory_AITEXT_VLLM("AITEXT_VLLM", this.BH)),
      this.categoryWithContext('#6A1B9A', 'ri-openai-line', () => ExpertCategory_AITEXT_OPENAI("AITEXT_OPENAI", this.BH)),
      this.categoryWithContext('#AD1457', 'ri-volume-up-line', () => ExpertCategory_AUDIO("AUDIO", this.BH)),
      this.categoryWithContext('#37474F', 'ri-filter-line', () => ExpertCategory_BEFORE_SEND("BEFORE_SEND", this.BH)),
      this.categoryWithContext('#1A237E', 'ri-links-line', () => ExpertCategory_BOTAPI("BOTAPI", this.BH)),
      this.categoryWithContext('#4527A0', 'ri-bank-card-line', () => ExpertCategory_CARDS("CARDS", this.BH)),
      this.categoryWithContext('#880E4F', 'ri-user-smile-line', () => ExpertCategory_CHAT_AVATAR("CHAT_AVATAR", this.BH)),
      this.categoryWithContext('#ed9292', 'ri-mic-line', () => ExpertCategory_DIALOGRECORDER("DIALOGRECORDER", this.BH)),
      this.categoryWithContext('#5D4037', 'ri-history-line', () => ExpertCategory_DIALOGSTORE("DIALOGSTORE", this.BH)),
      this.categoryWithContext('#4E342E', 'ri-search-line', () => ExpertCategory_DOCSEARCH_FN("DOCSEARCH", this.BH)),
      this.categoryWithContext('#37474F', 'ri-layout-line', () => ExpertCategory_DOM("DOM", this.BH)),
      this.categoryWithContext('#37474F', 'ri-download-line', () => ExpertCategory_DOWNLOAD("DOWNLOAD", this.BH)),
      this.categoryWithContext('#33691E', 'ri-flashlight-line', () => ExpertCategory_EVENTS_FN("EVENTS", this.BH)),
      this.categoryWithContext('#E53935', 'ri-tv-line', () => ExpertCategory_FUSIONVIEW("FUSIONVIEW", this.BH)),
      this.categoryWithContext('#37474F', 'ri-tools-line', () => ExpertCategory_HELPER("HELPER", this.BH)),
      this.categoryWithContext('#37474F', 'ri-information-line', () => ExpertCategory_INFO("INFO", this.BH)),
      this.categoryWithContext('#E65100', 'ri-key-line', () => ExpertCategory_KEYVAL("KEYVAL", this.BH)),
      this.categoryWithContext('#37474F', 'ri-terminal-box-line', () => ExpertCategory_LOG("LOG", this.BH)),
      this.categoryWithContext('#004D40', 'ri-mail-send-line', () => ExpertCategory_MAIL("MAIL", this.BH)),
      this.categoryWithContext('#37474F', 'ri-code-s-slash-line', () => ExpertCategory_MISC("MISC", this.BH)),
      this.categoryWithContext('#1565C0', 'ri-message-3-line', () => ExpertCategory_MSG("MSG", this.BH)),
      this.categoryWithContext(BLOCKLY_COLORS.CAT_DATEN_INHALTE, 'ri-chat-forward-line', () => ExpertCategory_GROUPCHAT("GROUPCHAT", this.BH, this.groupchatChannelRegistry)),
      this.categoryWithContext('#00838F', 'ri-notification-3-line', () => ExpertCategory_OVERLAY("OVERLAY", this.BH)),
      this.categoryWithContext('#33691E', 'ri-window-line', () => ExpertCategory_PARENT("PARENT", this.BH)),
      this.categoryWithContext('#BF360C', 'ri-folder-keyhole-line', () => ExpertCategory_PROJECTKEYVAL("PROJECTKEYVAL", this.BH)),
      this.categoryWithContext('#EF6C00', 'ri-question-line', () => ExpertCategory_QUIZ_FN("QUIZ", this.BH)),
      this.categoryWithContext('#006064', 'ri-computer-line', () => ExpertCategory_SCORM("SCORM", this.BH)),
      this.categoryWithContext('#F57F17', 'ri-trophy-line', () => ExpertCategory_SCORE("SCORE", this.BH)),
      this.categoryWithContext('#FF8F00', 'ri-puzzle-line', () => ExpertCategory_SKILL("SKILL", this.BH)),
      this.categoryWithContext('#2E7D32', 'ri-stack-line', () => ExpertCategory_STAGE("STAGE", this.BH)),
      this.categoryWithContext('#1B5E20', 'ri-eye-line', () => ExpertCategory_SUPERVISOR("SUPERVISOR", this.BH)),
      this.categoryWithContext('#880E4F', 'ri-vidicon-line', () => ExpertCategory_VIDEO_AVATAR("VIDEO_AVATAR", this.BH)),
      this.categoryWithContext('#D32F2F', 'ri-video-line', () => ExpertCategory_VIMEO("VIMEO", this.BH)),
      this.categoryWithContext('#558B2F', 'ri-time-line', () => ExpertCategory_WAITFOR("WAITFOR", this.BH)),
      this.categoryWithContext('#00695C', 'ri-global-line', () => ExpertCategory_WEBHOOK("WEBHOOK", this.BH)),
      this.categoryWithContext('#C62828', 'ri-youtube-line', () => ExpertCategory_YOUTUBE("YOUTUBE", this.BH))
    ];
  }

  private seperator(gap = 20): BlocklyToolboxSep {
    const sep: BlocklyToolboxSep = { kind: 'sep', gap };
    return sep;
  }
}
